import { getFeature } from 'Cloud/Application/FeaturesEs6';

export const allowEditForOwner: boolean = getFeature('allow-edit-for-owner');
